import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWord from '@/components/HelloWorld'
import login from '@/components/login'
import Images from '@/components/images'
import platformTenant from "@/components/platformTenant"
import operate from "@/components/operate"
import OrderShare from "@/components/operate/order_share.vue"
import Paying from "@/components/paying/index.vue"
import pdfLook from "@/components/pdfLook.vue"
import White from "@/components/white/index.vue";
import TwoTenant from "@/components/twoTenant/index.vue"
import OperateRecord from "@/components/operateRecord/index.vue"
import AssaySystem from "@/components/assaySystem/index.vue"
import AssayAudit from "@/components/assayAudit/index.vue"
import ShopUpdate from "@/components/shopUpdate/index.vue"
import App from "@/components/app/index.vue"
import Map from "@/components/map/index.vue"
import AssaySell from '@/components/assaySell/index.vue'
import CoalSource from '@/components/coalSource/index.vue'
import ShopSpecial from '@/components/shopSpecial/index.vue'
import AssayStatistic from '@/components/assayStatistic/index.vue'
import TenantCount from '@/components/tenantCount/index.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'main'
      }
    },
    { path: '/main', name: 'main', component: HelloWord },
    { path: '/login', name: 'login', component: login },
    { path: '/sm', name: 'sm', component: Images },
    { path: '/tm', name: 'tm', component: Images },
    { path: '/fy', name: 'fy', component: Images },
    { path: '/sp', name: 'sp', component: Images },
    { path: '/pt', name: 'pt', component: platformTenant },
    { path: '/operate', name: 'operate', component: operate },
    { path: '/order_share', name: 'order_share', component: OrderShare },
    { path: '/paying', name: 'paying', component: Paying },
    { path: '/pdf', name: 'pdf', component: pdfLook },
    { path: '/white', name: 'white', component: White },
    { path: '/two', name: 'two', component: TwoTenant },
    { path: '/record', name: 'record', component: OperateRecord },
    { path: '/assay', name: 'assay', component: AssaySystem },
    { path: '/assayAudit', name: 'assayAudit', component: AssayAudit },
    { path: '/shopUpdate', name: 'shopUpdate', component: ShopUpdate },
    { path: '/app', name: 'app', component: App },
    { path: '/map', name: 'map', component: Map },
    { path: '/assaySell', name: 'assaySell', component: AssaySell },
    { path: '/coalSource', name: 'coalSource', component: CoalSource },
    { path: '/shopSpecial', name: 'shopSpecial', component: ShopSpecial },
    { path: '/assayStatistic', name: 'assayStatistic', component: AssayStatistic },
    { path: '/tenantCount', name: 'tenantCount', component: TenantCount }
  ]
})
router.beforeEach((to, _, next) => {
  if (to.path === "/login") {
    next();
  } else {
    const token = localStorage.getItem('token')
    if (token == null || token === "null" || token === "") {
      next("/login");
    } else {
      next();
    }
  }
})


export default router